import { NATURAL_PERSON_NAME_MAX_LENGTH } from './person';

export const requiredFieldMessage = 'Campo requerido';

export const naturalPersonNameMaxLengthMessage = `Máximo ${NATURAL_PERSON_NAME_MAX_LENGTH} caracteres`;

export const invalidChassisMessage = 'El número de chasis no es válido';

export const invalidEngineMessage = 'El número de motor no es válido';

export const validationMessages = [{ name: 'testingg' }];
